<script lang="ts" setup>
import { useSlots } from 'vue';

const slots = useSlots();
</script>

<template>
  <div class="trip-summary-card-layout" :class="{ 'has-image': slots.image }">
    <div v-if="slots.image" class="segment-image">
      <slot name="image" />
    </div>

    <div class="segment-content">
      <div class="segment-header">
        <slot name="header" />
      </div>
      <slot name="content" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.trip-summary-card-layout {
  display: flex;
  gap: var(--spacing-12);

  &.has-image {
    flex-direction: row;
  }

  &:not(.has-image) {
    flex: 1;
    flex-direction: column;
  }

  .segment-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: var(--spacing-8);
  }

  .segment-image {
    width: 60px;
    height: 60px;
    border-radius: var(--border-radius-8);
    overflow: hidden;
  }

  .segment-header {
    display: flex;
  }
}
</style>
